import Theme from '@adsk/alloy-react-theme';

export const optionStyle = {
  'display': 'flex',
  'alignItems': 'center',
  'marginBottom': '16px',
  ':last-child': {
    marginBottom: '0',
  },
};

export const checkboxTextStyle = {
  ...Theme.typography.bodyMedium,
  paddingLeft: '16px',
};

export const noPurchasedProductsTextStyle = {
  ...Theme.typography.bodyMedium,
  color: Theme.colors.charcoal500,
};

export const productsLabelStyle = {
  display: 'flex',
  alignItems: 'center',
  paddingBottom: '14px',
  color: Theme.colors.charcoal900,
  ...Theme.typography.bodyMediumBold,
};

export const tooltipIconStyle = {
  marginLeft: '5px',
  color: Theme.colors.charcoal700,
};
